import { Skeleton } from '@mui/material'

import { Organism } from '@/core/architecture'

export const RankListItemSkeleton: Organism = () => (
  <Skeleton height={72} variant="rectangular" sx={{ borderRadius: 1 }} />
)
